import { Link } from "react-router-dom";
import { ArrowRight, Zap, Cpu } from "lucide-react";

const SiloEntryBlocks = () => (
  <section className="py-14 lg:py-20 bg-background" aria-label="Product silos">
    <div className="container">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
        {/* Transformer silo */}
        <article className="group relative overflow-hidden rounded-2xl border border-border bg-card hover:border-brand/40 transition-all duration-300 hover:shadow-xl">
          <div className="p-8 md:p-10">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 rounded-xl bg-brand/10 flex items-center justify-center">
                <Zap className="w-6 h-6 text-brand" />
              </div>
              <span className="text-xs font-display uppercase tracking-wider text-muted-foreground">Power & Distribution</span>
            </div>
            <h2 className="font-display text-2xl md:text-3xl font-bold text-foreground mb-3">
              Transformer Solutions
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-6">
              Bushings, Buchholz relays, gaskets, cooling systems, monitoring devices, and tap changers for power and distribution transformers. Multi-brand inventory with engineering support.
            </p>
            <ul className="space-y-2 mb-7 text-sm text-foreground/80">
              <li>• ABB, Siemens, GE, Hitachi, Eaton, Hubbell, Pfisterer, Yash, TBEA, WEG</li>
              <li>• OEM and equivalent replacements</li>
              <li>• Hard-to-find and obsolete parts sourcing</li>
            </ul>
            <Link
              to="/transformer-parts"
              className="inline-flex items-center gap-2 text-brand font-semibold hover:gap-3 transition-all"
            >
              Enter Transformer Hub
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </article>

        {/* Automation silo */}
        <article className="group relative overflow-hidden rounded-2xl border border-border bg-card hover:border-brand/40 transition-all duration-300 hover:shadow-xl">
          <div className="p-8 md:p-10">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 rounded-xl bg-brand/10 flex items-center justify-center">
                <Cpu className="w-6 h-6 text-brand" />
              </div>
              <span className="text-xs font-display uppercase tracking-wider text-muted-foreground">Factory Automation</span>
            </div>
            <h2 className="font-display text-2xl md:text-3xl font-bold text-foreground mb-3">
              Industrial Automation Parts
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-6">
              PLCs, HMIs, servo drives, VFDs, power supplies, and communication modules from leading manufacturers. New stock from our Florida warehouse, ready to ship.
            </p>
            <ul className="space-y-2 mb-7 text-sm text-foreground/80">
              <li>• Allen-Bradley, Siemens, ABB, Schneider Electric, Mitsubishi, FANUC</li>
              <li>• Active and obsolete catalog numbers</li>
              <li>• Same-day quotes from US inventory</li>
            </ul>
            <Link
              to="/industrial-automation-parts"
              className="inline-flex items-center gap-2 text-brand font-semibold hover:gap-3 transition-all"
            >
              Enter Automation Hub
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </article>
      </div>
    </div>
  </section>
);

export default SiloEntryBlocks;
